var _jsxFileName = "/codebuild/output/src1493404089/src/bitbucket.org/newyuinc/adc-polaris-web/src/hooks/useAuth.tsx";
import React, { useCallback, useEffect, useState } from 'react';
import { Stack, Text } from '@adc/parallax-component-library';
import { AppLicensingVerdict, AppRecognitionVerdict } from 'Constants';
import { RichText } from 'Components/utility';
import { CLOSE_MODAL, SHOW_MODAL } from 'Reducers/modal/types';
import { notifyApp } from 'Utilities/appCommunicator';
import { setCountryRedirectUrl } from 'Utilities/dataHelpers';
import { getDifferenceInMinutesFromNow } from 'Utilities/dateHelpers';
import i18n from 'Utilities/i18n';
import { logout } from 'Utilities/session';
import { getObject, removeObject, setObject } from 'Utilities/storage';
import { store } from 'Utilities/store';
const translationsKeys = {
  login: {
    lockoutMessageTitleKey: 'Login.modals.signInErrors.accountLocked',
    lockoutMessageSubtitleKey: 'Login.modals.signInErrors.accountLockedPeriod',
    authErrorTitleKey: 'Login.modals.signInErrors.loginFailure',
    authErrorAttemptsRemainingKey: 'Login.modals.signInErrors.attemptsRemaining',
    authErrorLockedKey: 'Login.modals.signInErrors.accountWillBeLocked'
  },
  changepassword: {
    lockoutMessageTitleKey: 'ChangePassword.microcopy.lockoutBanner.messageItem_1',
    lockoutMessageSubtitleKey: 'ChangePassword.microcopy.lockoutBanner.messageItem_2',
    authErrorTitleKey: 'ChangePassword.modals.changePasswordErrors.attemptsRemainingError.title',
    authErrorAttemptsRemainingKey: 'ChangePassword.modals.changePasswordErrors.attemptsRemainingError.message',
    authErrorLockedKey: 'ChangePassword.modals.changePasswordErrors.noAttemptsRemainingError.message'
  }
};
const useAuth = type => {
  const [isLocked, setIsLocked] = useState(false);
  const [lockoutMessage, setLockoutMessage] = useState('');
  const [lockoutSubmessage, setlockoutSubmessage] = useState('');
  const [translationKeys, setTranslationKeys] = useState({
    lockoutMessageTitleKey: '',
    lockoutMessageSubtitleKey: '',
    authErrorTitleKey: '',
    authErrorAttemptsRemainingKey: '',
    authErrorLockedKey: ''
  });
  useEffect(() => {
    if (type) {
      const translationKeys = translationsKeys[type];
      setTranslationKeys(translationKeys);
    }
  }, [type]);
  const handleWrongRegionError = useCallback((error, showApiErrorModal, handleSubmit) => {
    var _error$response;
    const redirectUrl = (_error$response = error.response) === null || _error$response === void 0 || (_error$response = _error$response.headers) === null || _error$response === void 0 ? void 0 : _error$response['x-api-url'];
    if (!redirectUrl) {
      showApiErrorModal();
      return;
    }
    setCountryRedirectUrl(redirectUrl);
    handleSubmit();
  }, []);
  const showLockoutMessage = useCallback((attemptsResetAt, attemptsResetAfter) => {
    const {
      time,
      difference
    } = getDifferenceInMinutesFromNow(attemptsResetAt);
    if (difference < 0) {
      return;
    }
    setIsLocked(true);
    setLockoutMessage(i18n.t(translationKeys.lockoutMessageTitleKey));
    setlockoutSubmessage(i18n.t(translationKeys.lockoutMessageSubtitleKey, {
      time
    }));
    const lockoutInterval = setInterval(() => {
      const {
        time,
        difference
      } = getDifferenceInMinutesFromNow(attemptsResetAt);
      if (difference < 0) {
        clearInterval(lockoutInterval);
        setLockoutMessage('');
        setlockoutSubmessage('');
        setIsLocked(false);
        removeObject('loginLockout');
      } else {
        setlockoutSubmessage(i18n.t(translationKeys.lockoutMessageSubtitleKey, {
          time
        }));
      }
    }, 1000);
    setObject('loginLockout', {
      attemptsResetAt,
      lockoutInterval,
      attemptsResetAfter
    });
  }, [translationKeys.lockoutMessageSubtitleKey, translationKeys.lockoutMessageTitleKey]);
  const handleLockoutError = useCallback(error => {
    var _error$response2, _error$response3;
    const attemptsResetAfter = Number((_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : _error$response2.headers['x-attempts-reset-after']);
    const attemptsResetAt = Number((_error$response3 = error.response) === null || _error$response3 === void 0 ? void 0 : _error$response3.headers['x-attempts-reset-at']);
    showLockoutMessage(attemptsResetAt, attemptsResetAfter);
  }, [showLockoutMessage]);
  useEffect(() => {
    const loginLockout = getObject('loginLockout');
    if (loginLockout) {
      showLockoutMessage(loginLockout.attemptsResetAt, loginLockout.attemptsResetAfter);
    }
    return () => {
      const loginLockout = getObject('loginLockout');
      if (loginLockout) {
        clearInterval(loginLockout.lockoutInterval);
      }
    };
  }, [showLockoutMessage]);
  const showLoginFailure = useCallback((attemptsRemaining = -1, attemptsResetAfter, attemptsResetAt, onCloseAfterLockout, onClose) => {
    const modalProps = {
      details: /*#__PURE__*/React.createElement(Stack, {
        gap: "$4",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 155,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement(Text, {
        testID: translationKeys.authErrorTitleKey,
        nativeID: translationKeys.authErrorTitleKey,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 156,
          columnNumber: 13
        }
      }, i18n.t(translationKeys.authErrorTitleKey)), attemptsRemaining >= 0 ? /*#__PURE__*/React.createElement(Stack, {
        display: "inline",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 163,
          columnNumber: 15
        }
      }, /*#__PURE__*/React.createElement(Text, {
        testID: translationKeys.authErrorAttemptsRemainingKey,
        nativeID: translationKeys.authErrorAttemptsRemainingKey,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 164,
          columnNumber: 17
        }
      }, i18n.t(translationKeys.authErrorAttemptsRemainingKey, {
        count: attemptsRemaining
      })), attemptsResetAfter ? /*#__PURE__*/React.createElement(Text, {
        testID: translationKeys.authErrorLockedKey,
        nativeID: translationKeys.authErrorLockedKey,
        fontWeight: "$bodyBase.medium",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 173,
          columnNumber: 19
        }
      }, i18n.t(translationKeys.authErrorLockedKey, {
        time: attemptsResetAfter,
        duration: attemptsResetAfter
      })) : null) : null),
      testID: 'Auth'
    };
    modalProps.onClose = () => {
      onClose && onClose();
    };
    if (attemptsResetAfter && attemptsResetAt) {
      modalProps.onClose = () => {
        showLockoutMessage(attemptsResetAt, attemptsResetAfter);
        onCloseAfterLockout && onCloseAfterLockout();
      };
    }
    store.dispatch({
      type: SHOW_MODAL,
      modalProps
    });
  }, [showLockoutMessage, translationKeys.authErrorAttemptsRemainingKey, translationKeys.authErrorLockedKey, translationKeys.authErrorTitleKey]);
  const handleLoginError = useCallback((error, onCloseAfterLockout, onClose) => {
    var _error$response4;
    if (((_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : _error$response4.data.details) === 'Authorization.isRequired') {
      logout();
      return;
    }
    if (error.response && error.response.headers['x-attempts-remaining']) {
      const attemptsRemaining = Number(error.response.headers['x-attempts-remaining']);
      const attemptsResetAt = error.response.headers['x-attempts-reset-at'] ? Number(error.response.headers['x-attempts-reset-at']) : 0;
      const attemptsResetAfter = error.response.headers['x-attempts-reset-after'] ? Number(error.response.headers['x-attempts-reset-after']) / 60 : 0;
      showLoginFailure(attemptsRemaining, attemptsResetAfter, attemptsResetAt, onCloseAfterLockout, onClose);
      return;
    }
    showLoginFailure();
  }, [showLoginFailure]);
  const showHcpError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 251,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(RichText, {
          testID: "Global.modals.blockHCPUser.body",
          text: i18n.t('Global.modals.blockHCPUser.body', {
            appName: i18n.t('Global.appNames.libreView')
          }),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 252,
            columnNumber: 13
          }
        })),
        testID: 'Auth'
      }
    });
  }, []);
  const showAndroidIntegrityErrorMessage = useCallback((key, onClose) => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        onClose,
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 271,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(RichText, {
          text: i18n.t(key),
          testID: key,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 272,
            columnNumber: 13
          }
        }))
      }
    });
  }, []);
  const handleAndroidIntegrityAppMessage = useCallback((headers, error) => {
    var _error$response5;
    const verdictDeviceRecognition = headers === null || headers === void 0 ? void 0 : headers['x-verdict-device-recognition'];
    const verdictAppRecognition = headers === null || headers === void 0 ? void 0 : headers['x-verdict-app-recognition'];
    const verdictAppLicensing = headers === null || headers === void 0 ? void 0 : headers['x-verdict-app-licensing'];
    const deviceActivityLevel = headers === null || headers === void 0 ? void 0 : headers['x-verdict-device-activity-level'];
    const notifyAppData = {
      errors: error === null || error === void 0 || (_error$response5 = error.response) === null || _error$response5 === void 0 ? void 0 : _error$response5.data.errors,
      verdictDeviceRecognition: verdictDeviceRecognition ?? '',
      verdictAppRecognition: verdictAppRecognition ?? '',
      verdictAppLicensing: verdictAppLicensing ?? '',
      deviceActivityLevel: deviceActivityLevel ?? ''
    };
    notifyApp('adc-webview:api-integrity', notifyAppData);
  }, []);
  const handleSignInSuccessAppMessage = useCallback(authSession => {
    const {
      headers,
      ...authSessionWithoutHeaders
    } = authSession;
    notifyApp('adc-webview:signin', authSessionWithoutHeaders);
    const {
      osType,
      app,
      appHash
    } = store.getState().env;
    if (osType === 'Android' && app === 'libre1' && appHash) {
      handleAndroidIntegrityAppMessage(headers);
    }
  }, [handleAndroidIntegrityAppMessage]);
  const handleAndroidIntegrityError = useCallback(error => {
    if (!error.response) {
      return;
    }
    const {
      headers
    } = error.response;
    const verdictAppRecognition = headers['x-verdict-app-recognition'];
    const verdictAppLicensing = headers['x-verdict-app-licensing'];
    if (verdictAppRecognition === AppRecognitionVerdict.UNRECOGNIZED_VERSION) {
      showAndroidIntegrityErrorMessage('Global.modals.androidIntegrityErrors.versionNotSupported', () => {
        handleAndroidIntegrityAppMessage(headers, error);
      });
      return;
    }
    if (verdictAppLicensing === AppLicensingVerdict.UNLICENSED) {
      showAndroidIntegrityErrorMessage('Global.modals.androidIntegrityErrors.reinstallApp', () => {
        handleAndroidIntegrityAppMessage(headers, error);
      });
      return;
    }

    // TODO: The following cases are currently unhandled (app terminates with no error message):
    // - verdictStatus: REQUEST_HASH_TOO_LONG, APP_NOT_INSTALLED, APP_UID_MISMATCH, INTERNAL_ERROR, CLOUD_PROJECT_NUMBER_IS_INVALID, TOO_MANY_REQUESTS, NO_ERROR
    // - appRecognitionVerdict, deviceRecognitionVerdict, appLicensingVerdict: UNEVALUATED or empty
    // - deviceRecognitionVerdict: array does not contain MEETS_DEVICE_INTEGRITY
    // - deviceActivityLevel: LEVEL_4, LEVEL_1, LEVEL_2, LEVEL_3
    // -  Review if future requirements change.
    handleAndroidIntegrityAppMessage(headers, error);
  }, [handleAndroidIntegrityAppMessage, showAndroidIntegrityErrorMessage]);
  const showDefaultLoginError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Login.modals.signInErrors.loginFailure'),
        testID: 'Auth'
      }
    });
  }, []);
  const showCountryRegionError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Login.modals.signInErrors.regionDoesNotMatch'),
        testID: 'Auth'
      }
    });
  }, []);
  const showCountryNotSupportedError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: i18n.t('Login.modals.signInErrors.countryNotSupported'),
        testID: 'Auth'
      }
    });
  }, []);
  const showAppUpgradeError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        header: i18n.t('Login.modals.updateApp.title'),
        details: /*#__PURE__*/React.createElement(Text, {
          type: "$bodyBase.default",
          nativeID: "Login.modals.updateApp.title",
          testID: "Login.modals.updateApp.title",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 392,
            columnNumber: 11
          }
        }, i18n.t('Login.modals.updateApp.body')),
        primaryAction: {
          label: i18n.t('Global.microcopy.common.update'),
          onPress: () => {
            const {
              androidAppURL,
              iosAppURL
            } = store.getState().config;
            const {
              osType
            } = store.getState().env;
            const storeLink = osType === 'iOS' ? iosAppURL : androidAppURL;
            if (storeLink) {
              window.open(storeLink);
            }
            store.dispatch({
              type: CLOSE_MODAL
            });
          }
        },
        testID: 'Auth'
      }
    });
  }, []);
  const showSessionManagementError = useCallback(onForceSignIn => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 428,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(RichText, {
          testID: "Global.modals.supportNewNSInstanceLogin.body",
          text: i18n.t('Global.modals.supportNewNSInstanceLogin.body', {
            appName: i18n.t('Global.appNames.libreView')
          }),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 429,
            columnNumber: 13
          }
        })),
        primaryAction: {
          label: i18n.t('Global.microcopy.common.okCap'),
          onPress: () => {
            onForceSignIn();
            store.dispatch({
              type: CLOSE_MODAL
            });
          }
        },
        secondaryAction: {
          label: i18n.t('Global.microcopy.common.cancel'),
          onPress: () => {
            store.dispatch({
              type: CLOSE_MODAL
            });
          }
        },
        testID: 'Auth'
      }
    });
  }, []);
  const showTokenExpirationError = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 464,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(RichText, {
          testID: "Global.modals.linkNotValid.title",
          text: i18n.t('Global.modals.linkNotValid.title'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 465,
            columnNumber: 13
          }
        }), /*#__PURE__*/React.createElement(Text, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 469,
            columnNumber: 13
          }
        }, i18n.t('Global.modals.linkNotValid.body'))),
        testID: 'Auth'
      }
    });
  }, []);
  const showForgotPasswordBlockedMessage = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 482,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          testID: "ForgotPassword.modals.forgotErrors.youReached",
          nativeID: "ForgotPassword.modals.forgotErrors.youReached",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 483,
            columnNumber: 13
          }
        }, i18n.t('ForgotPassword.modals.forgotErrors.youReached')), /*#__PURE__*/React.createElement(Text, {
          testID: "ForgotPassword.modals.forgotErrors.consider",
          nativeID: "ForgotPassword.modals.forgotErrors.consider",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 489,
            columnNumber: 13
          }
        }, i18n.t('ForgotPassword.modals.forgotErrors.consider'))),
        testID: 'Auth'
      }
    });
  }, []);
  const showForgotPasswordConfirmationMessage = useCallback(() => {
    store.dispatch({
      type: SHOW_MODAL,
      modalProps: {
        details: /*#__PURE__*/React.createElement(Stack, {
          gap: "$4",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 507,
            columnNumber: 11
          }
        }, /*#__PURE__*/React.createElement(Text, {
          testID: "ForgotPassword.modals.forgotErrors.sentInstructions",
          nativeID: "ForgotPassword.modals.forgotErrors.sentInstructions",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 508,
            columnNumber: 13
          }
        }, i18n.t('ForgotPassword.modals.forgotErrors.sentInstructions')), /*#__PURE__*/React.createElement(Text, {
          testID: "ForgotPassword.modals.forgotErrors.notSeeingEmail",
          nativeID: "ForgotPassword.modals.forgotErrors.notSeeingEmail",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 514,
            columnNumber: 13
          }
        }, i18n.t('ForgotPassword.modals.forgotErrors.notSeeingEmail'))),
        testID: 'Auth'
      }
    });
  }, []);
  return {
    handleLoginError,
    handleLockoutError,
    handleWrongRegionError,
    showHcpError,
    isLocked,
    lockoutMessage,
    lockoutSubmessage,
    showSessionManagementError,
    showTokenExpirationError,
    showForgotPasswordBlockedMessage,
    showForgotPasswordConfirmationMessage,
    showCountryRegionError,
    showCountryNotSupportedError,
    handleAndroidIntegrityError,
    handleSignInSuccessAppMessage,
    showDefaultLoginError,
    showAppUpgradeError
  };
};
export default useAuth;